export enum BookingInterval {
  HISTORICAL = "HISTORICAL",
  UPCOMING = "UPCOMING",
}